// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './fonts.css';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";




// Recharts' ResponsiveContainer uses ResizeObserver, which can trigger resize callbacks during sidebar collapse/expand layout updates.
// This may cause the harmless "ResizeObserver loop completed with undelivered notifications" warning in development.
// Suppressed this specific browser warning globally since chart rendering continues normally on the next animation frame.

(() => {
  const OriginalResizeObserver = window.ResizeObserver;
  if (!OriginalResizeObserver) return;
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
})();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);